import { render, staticRenderFns } from "./ResolvePendingConnector.vue?vue&type=template&id=bad6d290&scoped=true"
import script from "./ResolvePendingConnector.vue?vue&type=script&lang=ts"
export * from "./ResolvePendingConnector.vue?vue&type=script&lang=ts"
import style0 from "./ResolvePendingConnector.vue?vue&type=style&index=0&id=bad6d290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad6d290",
  null
  
)

export default component.exports